import { render, staticRenderFns } from "./two_factor_authentication_page.vue?vue&type=template&id=2a5e2db6"
import script from "./two_factor_authentication_page.vue?vue&type=script&lang=js"
export * from "./two_factor_authentication_page.vue?vue&type=script&lang=js"
import style0 from "./two_factor_authentication_page.vue?vue&type=style&index=0&id=2a5e2db6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports